import React from 'react';
import { AiOutlineCheck, AiOutlineClose, AiOutlineSync } from 'react-icons/ai';

const SyncStatusIndicator = ({ syncStatus }) => {
  // Handle null as loading, false as error, true as success
  const isSynced = syncStatus === true;
  const isLoading = syncStatus === null;
  const isFailed = syncStatus === false;

  const description = isSynced
    ? "Synchronisé avec le système ERP"
    : isLoading
      ? "Synchronisation en attente"
      : "Échec de synchronisation";

  return (
    <div className="flex items-center justify-center group">
      <div
        className={`sync-indicator relative p-1.5 rounded-full flex items-center justify-center w-7 h-7
          ${isSynced ? 'bg-emerald-50 shadow-sm border border-emerald-200' :
          isLoading ? 'bg-gray-50 shadow-sm border border-gray-200' :
          'bg-red-50 shadow-sm border border-red-200'}`}
        title={description}
      >
        {isSynced ? (
          <AiOutlineCheck className="text-emerald-500 text-lg sync-success" />
        ) : isLoading ? (
          <AiOutlineSync className="text-gray-400 text-lg sync-loading" />
        ) : (
          <AiOutlineClose className="text-red-500 text-lg sync-error" />
        )}
        <span className="sr-only">{description}</span>

        {/* Description tooltip on hover */}
        <div className="opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap">
          {description}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
        </div>
      </div>
    </div>
  );
};

export default SyncStatusIndicator;